export default __webpack_public_path__ + "static/media/Guardians.df4083eb.png";